import { render, staticRenderFns } from "./opTableLocal.vue?vue&type=template&id=2805cc7f&"
import script from "./opTableLocal.vue?vue&type=script&lang=ts&"
export * from "./opTableLocal.vue?vue&type=script&lang=ts&"
import style0 from "./opTableLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports